import Nullstack from 'nullstack';
export default function IconWheelchairOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-wheelchair-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "8",
    cy: "16",
    r: "5"
  }), "   ", Nullstack.element("path", {
    d: "M17.582 17.59a2 2 0 0 0 2.833 2.824"
  }), "   ", Nullstack.element("path", {
    d: "M14 14h-1.4"
  }), "   ", Nullstack.element("path", {
    d: "M6 6v5"
  }), "   ", Nullstack.element("path", {
    d: "M6 8h2m4 0h5"
  }), "   ", Nullstack.element("path", {
    d: "M15 8v3"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}